<div [id]="bindingId" style="display: grid;">
    <span #contentHost [innerHtml]="content" [ngClass]="class"></span>

    @if (showTooltip()) {
    <forge-tooltip placement="bottom" [target]="targetId" [innerHtml]="content"></forge-tooltip>
    }
</div>